export default __webpack_public_path__ + "static/media/image9.9b84274c.jpeg";